var code = {
    vote: {
        1: '感谢指挥官！相信画师已经收到了您的鼓励~',
        10: '参数错误',
        13: '签名错误',
        14: '活动配置不存在',
        46: '活动未开启',
        11601: '作品不存在',
        11602: '抱歉指挥官，系统出现不明异常，辛苦指挥官再试一下呀！）',
        11603: '抱歉指挥官，系统出现不明异常，辛苦指挥官再试一下呀！',
        11508: '今天的点赞次数已经用完，指挥官明天再来吧！',
        11514: '指挥官已经点赞过该作品啦~可以试试对其他的作品点赞哟！',
        11900: '每天最多投稿3次哦，指挥官明天再来吧~',
        503101: '角色不存在',
        "other": '异常错误：',
    }
}
export {
    code
}